<script>
  import ItemResponse from "./ItemResponse.svelte";
  export let inputFocusAction,
    inputBlurAction,
    updateLayer,
    currLayer,
    currLayerPrev;
</script>

<!-- point -->
<div class="dupo-menu-pane mb-2">
  <div class="dupo-menu-pane-row">
    <h3 class="h-sub">Mark details</h3>
  </div>
</div>
<div class="dupo-menu-pane mb-2">
  <ItemResponse
    type="inline-check"
    token="clip"
    title="Clip mark"
    value={currLayer.mark.clip}
    {inputFocusAction}
    {inputBlurAction}
    changeAction={(event) => {
      updateLayer(event, "mark.clip", currLayerPrev);
    }}
  />
</div>
<div class="dupo-menu-pane mb-2">
  <ItemResponse
    type="inline-check"
    token="point"
    title="Use point"
    value={currLayer.mark.point !== undefined}
    {inputFocusAction}
    {inputBlurAction}
    changeAction={(event) => {
      updateLayer(event, "mark.point", currLayerPrev);
    }}
  />
</div>
{#if currLayer.mark.point !== undefined}
  <!-- let areaSpecial = [
  { name: "Clip", key: "clip", value_type: "boolean", input_type: "checkbox" },
  { name: "Point", key: "point.point", value_type: "boolean", input_type: "checkbox" },
  { name: "Point filled", key: "point.filled", value_type: "boolean", input_type: "checkbox" },
  { name: "Point size", key: "point.size", value_type: "number", input_type: "number" },
] -->
  <div class="dupo-menu-pane mb-2">
    <ItemResponse
      type="inline-check"
      token="point-filled"
      title="Fill point"
      value={currLayer.mark.point?.filled}
      {inputFocusAction}
      {inputBlurAction}
      changeAction={(event) => {
        updateLayer(event, "mark.point.filled", currLayerPrev);
      }}
    />
  </div>
  <div class="dupo-menu-pane mb-2">
    <ItemResponse
      type="size"
      token="point-size"
      title="Point size"
      value={currLayer.mark.point?.size}
      {inputFocusAction}
      {inputBlurAction}
      changeAction={(event) => {
        updateLayer(event, "mark.point.size", currLayerPrev);
      }}
    />
  </div>
{/if}
